import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  updateReverseItem,
  getFileBlob,
  uploadItemValidate,
} from "./journeyAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "journey/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk("journey/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchIdNoloading = createAsyncThunk(
  "journey/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk("journey/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const editItem = createAsyncThunk(
  "journey/editItem",
  async (payload) => {
    const response = await updateItem(payload);
    return response;
  }
);
export const editReverseItem = createAsyncThunk(
  "journey/editReverseItem",
  async (payload) => {
    const response = await updateReverseItem(payload);
    return response;
  }
);
export const removeById = createAsyncThunk(
  "journey/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const fetchFileBlob = createAsyncThunk(
  "journey/fetchFileBlob",
  async (id) => {
    console.log(id, "id slice");
    const response = await getFileBlob(id);
    return response;
  }
);
export const uploadValidate = createAsyncThunk(
  "journey/uploadValidate",
  async (payload) => {
    const response = await uploadItemValidate(payload);
    return response;
  }
);

export const journeySlice = createSlice({
  name: "journey",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editReverseItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editReverseItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = journeySlice.actions;

export const selectData = (state) => state.journey.data;
export const selectId = (state) => state.journey.dataId;
export const selectLoading = (state) => state.journey.loading;
export const selectError = (state) => state.journey.error;
export const selectPageNo = (state) => state.journey.pageNo;
export const selectPageSize = (state) => state.journey.pageSize;
export const selectTotalRecord = (state) => state.journey.totalRecord;
export const selectSelected = (state) => state.journey.selected;
export const selectResult = (state) => state.journey.result;

export default journeySlice.reducer;
